// src/frontend_react/src/utils/analytics.js

export const trackEvent = (eventName, eventProperties = {}) => {
  // In a real application, this would send data to a service like Google Analytics, Mixpanel, etc.
  // For now, we just log it to the console for development and debugging purposes.

  console.log(`[ANALYTICS EVENT]: ${eventName}`, {
    ...eventProperties,
    timestamp: new Date().toISOString(),
    url: window.location.pathname,
  });
};
